import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { motion } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import * as FaIcons from 'react-icons/fa';
import SafeIcon from '../common/SafeIcon';

const { FiHome, FiDroplet, FiCoffee, FiTrendingUp, FiCalendar, FiTool, FiCamera } = FiIcons;
const { FaFish } = FaIcons;

const navigationItems = [
  { path: '/', label: 'Dashboard', icon: FiHome, color: 'bg-aqua-500', tip: 'Overview of all key metrics' },
  { path: '/water-test', label: 'Water Test', icon: FiDroplet, color: 'bg-blue-500', tip: 'Monitor water parameters' },
  { path: '/feeding', label: 'Feeding', icon: FiCoffee, color: 'bg-green-500', tip: 'Track feed amounts' },
  { path: '/growth', label: 'Growth', icon: FiTrendingUp, color: 'bg-purple-500', tip: 'Record fish measurements' },
  { path: '/maintenance', label: 'Maintenance', icon: FiTool, color: 'bg-orange-500', tip: 'Schedule upkeep tasks' },
  { path: '/timeline', label: 'Timeline', icon: FiCalendar, color: 'bg-amber-500', tip: 'View upcoming tasks' },
  { path: '/images', label: 'Images', icon: FiCamera, color: 'bg-pink-500', tip: 'Document with photos' }
];

const QuickActionBar = () => {
  const location = useLocation();

  return (
    <div className="fixed bottom-0 left-0 right-0 z-40 bg-white bg-opacity-90 backdrop-blur-sm border-t border-gray-200 py-2 px-4">
      <div className="flex justify-between items-center overflow-x-auto pb-1">
        {navigationItems.map((item) => (
          <motion.div
            key={item.path}
            whileTap={{ scale: 0.95 }}
            className="relative group"
          >
            <Link
              to={item.path}
              className="flex flex-col items-center space-y-1 px-2"
            >
              <div
                className={`w-12 h-12 ${item.color} ${
                  location.pathname === item.path ? 'ring-2 ring-gray-300' : ''
                } rounded-full flex items-center justify-center shadow-sm`}
              >
                <SafeIcon icon={item.icon} className="w-5 h-5 text-white" />
              </div>
              <span
                className={`text-xs font-medium ${
                  location.pathname === item.path ? 'text-gray-900' : 'text-gray-600'
                }`}
              >
                {item.label}
              </span>
            </Link>
            {/* Tooltip */}
            <div className="absolute bottom-full left-1/2 transform -translate-x-1/2 mb-2 px-2 py-1 bg-gray-800 text-white text-xs rounded opacity-0 group-hover:opacity-100 transition-opacity whitespace-nowrap">
              {item.tip}
            </div>
          </motion.div>
        ))}
      </div>
    </div>
  );
};

export default QuickActionBar;